module.exports = __webpack_public_path__ + "img/t-photo.c763a44e.png";